import { render, staticRenderFns } from "./provider-products-v2.modal.vue?vue&type=template&id=03aab918&scoped=true"
import script from "./provider-products-v2.modal.vue?vue&type=script&lang=js"
export * from "./provider-products-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./provider-products-v2.modal.vue?vue&type=style&index=0&id=03aab918&prod&lang=scss&scoped=true"
import style1 from "./provider-products-v2.modal.vue?vue&type=style&index=1&id=03aab918&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aab918",
  null
  
)

export default component.exports